module.exports = __webpack_public_path__ + "static/img/news_26.b1912d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_26.png
// module id = ARab
// module chunks = 2